import service from '@/util/service';

// acceptance
export const getAcceptanceList = params => service.jsonGet('/api/business/acceptance/list', params);

export const getAcceptance = params => service.jsonGet('/api/business/acceptance/view', params);

export const applyAcceptance = params => service.jsonPost('/api/business/acceptance/apply', params);

export const approveAcceptance = params => service.jsonPost('/api/business/acceptance/approve', params);

export const cancelAcceptance = params => service.jsonPost('/api/business/acceptance/cancel', params);



// WEBPACK FOOTER //
// ./src/api/acceptance/index.js